import { render, staticRenderFns } from "./ReviewDataExtractionSettingsController.vue?vue&type=template&id=92ef3e04&scoped=true&"
import script from "./ReviewDataExtractionSettingsController.vue?vue&type=script&lang=js&"
export * from "./ReviewDataExtractionSettingsController.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDataExtractionSettingsController.vue?vue&type=style&index=0&id=92ef3e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ef3e04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
